"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_CANCEL_MODAL = void 0;
exports.CREDIT_BUILDER_CANCEL_MODAL = {
    HEADER: 'Cancel membership',
    CTA: 'Confirm cancel',
    REJECT_CTA: 'Never mind',
    BODY: 'Staring with your {{nextBpMonth}} bill:',
    BULLETS: [
        'You will be responsible for paying your own rent',
        'Flex will close the credit line used to make rent payments',
        'Flex will close your credit reporting line, which may hurt your credit score',
    ],
    BODY_BOLD: 'If you’d like to use Flex again in the future, you’ll have to re-apply.'
};
